// export default () => ({
// })

export default () => ({
    roles: [],
    rolesSelectable: [],
    rolSelect: null,
    rolesPaginatedData: null,
    rol: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,
})